import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from './Generic/Link';
import { addClassNames } from '../Functions/Helper/Component';
import useRole from '../Provider/TableContext/RoleContext';
import RoleStatus from '../Constants/RoleStatus.json';

import { 
    Person as PersonIcon,
    RocketTakeoff as AchievementsIcon,
    ClipboardCheck as JobApplicationIcon,
    ClipboardHeart as IdealJobIcon,
    GraphUp as DashboardIcon,
    CloudDownload as DownloadIcon,
    FileEarmarkText as CVsIcon
} from './Generic/Icons';
import useConstant from '../Provider/ConstantContext';
import LinkToJourney from './Generic/LinkToJourney';

export function SideNav({ className }) {
    const { pathname: _pn } = useLocation();
    const { portalURL } = useConstant();
    const pathname = _pn.toLowerCase();
    const [isIdealJobVisible, setIdealJobVisible] = React.useState(false);
    const { roles, loading: roleLoading } = useRole();

    React.useEffect(() => {
        const idealJob = document.getElementById('ideal-job');
        if (idealJob) {
            const observe = (() => {      
                const rect = idealJob.getBoundingClientRect();
                const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
                
                const coverage = visibleHeight / window.innerHeight; // % of the element visible
                if (coverage > 0.66 || (rect.top >= 0 && rect.bottom <= window.innerHeight && !window.location.hash.includes('ideal-job'))) {
                    window.history.replaceState(null, null, "#ideal-job");
                    setIdealJobVisible(true);
                } else {
                    if (window.location.hash === "#ideal-job") window.history.replaceState(null, null, " ");
                    setIdealJobVisible(false);
                }
            });

            window.addEventListener("scroll", observe);
            window.addEventListener("resize", observe);
            return () => {
                window.removeEventListener("scroll", observe);
                window.removeEventListener("resize", observe);
            }
        }
    });

    const genericCvId = React.useMemo(() => {
        if (!roleLoading) {
            const idealRole = roles.find(role => role.mcb_rolestatus === RoleStatus.Ideal);
            if (idealRole && idealRole?._mcb_cv_value) {
                return idealRole._mcb_cv_value;
            }
        }
        return false;
    }, [roles, roleLoading]);

    const scrollToTop = React.useCallback(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    return (
        <>
            <ul className={addClassNames("nav nav-pills", className)}>
                <li className="nav-item">
                    <LinkToJourney onClick={scrollToTop} className={addClassNames('nav-link unstyled', pathname.startsWith("/profile") && !isIdealJobVisible ? 'active' : '')} to="/profile">
                        <PersonIcon className="icon fs-4" /> Profile
                    </LinkToJourney>
                </li>
                <li className="nav-item">
                    <Link
                        to="/"
                        onClick={scrollToTop}
                        className={addClassNames('nav-link unstyled', pathname === "/" && !isIdealJobVisible ? 'active' : '')}
                    >
                        <DashboardIcon className="icon fs-4" /> Dashboard
                    </Link>
                </li>
                <li className="nav-item">
                    <Link
                        to="/achievements"
                        onClick={scrollToTop}
                        className={addClassNames('nav-link unstyled', pathname.startsWith("/achievements") && !isIdealJobVisible ? 'active' : '')}
                    ><AchievementsIcon className="icon fs-4" /> Achievements</Link>
                </li>
                <li className="nav-item">
                    <Link
                        to="/#ideal-job"
                        onClick={(e) => {
                            const idealJob = document.getElementById('ideal-job');
                            if (idealJob) {
                                idealJob.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                        className={addClassNames('nav-link unstyled', isIdealJobVisible ? 'active' : '')}
                    ><IdealJobIcon className="icon fs-4" /> Ideal Job</Link>
                </li>
                <li className="nav-item">
                    <Link
                        to="/job-applications"
                        onClick={scrollToTop}
                        className={addClassNames('nav-link unstyled', pathname.startsWith("/job-applications") && !isIdealJobVisible ? 'active' : '')}
                    ><JobApplicationIcon className="icon fs-4" /> Job Applications</Link>
                </li>
                <li className="nav-item">
                    <Link
                        to="/cvs"
                        onClick={scrollToTop}
                        className={addClassNames('nav-link unstyled', pathname.startsWith("/cvs") && !isIdealJobVisible ? 'active' : '')}
                    ><CVsIcon className="icon fs-4" /> CVs</Link>
                </li>
            </ul>


            {genericCvId && !(_pn.startsWith("/cvs") || _pn.startsWith("/job-applications")) && (
                <div className='d-flex position-sticky flex-row justify-content-end gap-3 b-4'>
                    <a
                        target='_blank'
                        rel='noreferrer'
                        href={`${portalURL}File/download.aspx?Entity=mcb_cv&Attribute=mcb_cvdocument&Id=${genericCvId}`}
                        className='btn btn-primary w-max-content unstyled align-self-end'
                    ><DownloadIcon className="icon" /> Download CV</a>
                </div>
            )}
        </>
    );
}
